import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { callCreateNewClient } from './firebase'; // 🔥 استيراد الدالة المساعدة
import { supabase } from './supabaseClient';
import { signInWithPassword } from './lib/supabaseAuth';

function SignupPage() {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    brandName: '',
    telegramId: '',
    countryCode: '20',
    facebookUrl: '',
    instagramUrl: '',
    platform: 'easyorder', // EasyOrder only
    easyOrderDomain: '',
    easyOrderStoreId: '',
    easyOrderApiKey: '',
    messageLanguage: 'ar',
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: name === 'telegramId' ? value.replace(/\D/g, '') : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      // إرسال البيانات للـ Cloud Function
      const result = await callCreateNewClient(formData);

      if (result.status === 'success') {
        // 🔓 دخول تلقائي بعد إنشاء الحساب — من غير الجزء ده كان بيتنقل
        // لـ /dashboard بلا أي جلسة GoTrue فالجارد في App.js بيرجّعه
        // لشاشة اللوجين. الأولوية للجلسة اللي السيرفر بيرجّعها جاهزة
        // (result.session)، وfallback لتسجيل دخول بنفس الإيميل/الباسورد
        // اللي المستخدم لسه كاتبهم، وآخر حل: صفحة اللوجين زي زمان.
        let signedIn = false;
        try {
          if (result.session && result.session.access_token && result.session.refresh_token) {
            const { error: sessionError } = await supabase.auth.setSession({
              access_token: result.session.access_token,
              refresh_token: result.session.refresh_token,
            });
            signedIn = !sessionError;
          }
          if (!signedIn) {
            const { error: signInError } = await signInWithPassword(formData.email, formData.password);
            signedIn = !signInError;
          }
        } catch (autoLoginErr) {
          console.warn('Auto-login after signup failed:', autoLoginErr);
        }

        if (signedIn) {
          navigate('/dashboard');
        } else {
          alert('تم إنشاء الحساب بنجاح! سجّل دخولك بنفس الإيميل والباسورد.');
          navigate('/');
        }
      } else {
        setError(result.message || 'حدث خطأ غير معروف');
      }
    } catch (error) {
      if (error.message.includes('already-exists') || error.message.includes('مسجل بالفعل') || error.message.includes('مستخدم')) {
        setError(error.message || 'الاسم أو البيانات مسجلة بالفعل');
      } else {
        setError(error.message);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px 0' }}>
      <div style={{ background: 'rgba(30, 30, 47, 0.95)', borderRadius: '20px', padding: '40px', boxShadow: '0 20px 60px rgba(0, 0, 0, 0.5)', maxWidth: '600px', width: '100%', margin: '0 20px' }}>
        <h2 style={{textAlign: 'center', color: '#8be9fd', marginBottom: '10px'}}>إنشاء حساب براند جديد</h2>
        <p style={{textAlign: 'center', color: '#f8f8f2', marginBottom: '30px', fontSize: '14px'}}>املأ البيانات التالية لإنشاء حسابك</p>
        
        <form onSubmit={handleSubmit}>
          <div style={fieldGroupStyle}>
            <label style={labelStyle}>الإيميل</label>
            <input 
              type="email" 
              name="email" 
              placeholder="أدخل البريد الإلكتروني" 
              value={formData.email} 
              onChange={handleChange} 
              required 
              style={inputStyle} 
            />
          </div>
          
          <div style={fieldGroupStyle}>
            <label style={labelStyle}>كلمة المرور</label>
            <input 
              type="password" 
              name="password" 
              placeholder="أدخل كلمة المرور" 
              value={formData.password} 
              onChange={handleChange} 
              required 
              style={inputStyle} 
            />
          </div>
          
          <div style={fieldGroupStyle}>
            <label style={labelStyle}>اسم البراند</label>
            <input 
              type="text" 
              name="brandName" 
              placeholder="مثال: MyBrand (بالإنجليزي فقط)" 
              value={formData.brandName} 
              onChange={handleChange} 
              required 
              style={inputStyle} 
            />
            <div style={{ marginTop: '6px', fontSize: '12px', color: '#ff5555', fontWeight: 'bold' }}>
              ⚠️ مهم: اكتب الاسم بالإنجليزي فقط (حروف وأرقام بدون مسافات أو رموز)
            </div>
          </div>
          
          <div style={fieldGroupStyle}>
            <label style={labelStyle}>
              Telegram ID
              <span 
                title="روح لبوت @get_id_bot على تليجرام واضغط start هيجيبلك User ID: 898009355"
                style={{ 
                  cursor: 'help',
                  fontSize: '14px',
                  fontWeight: 'bold',
                  color: '#8be9fd',
                  marginLeft: '8px',
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '18px',
                  height: '18px',
                  borderRadius: '50%',
                  border: '2px solid #8be9fd',
                  lineHeight: '1',
                  verticalAlign: 'middle'
                }}
              >
                ?
              </span>
            </label>
            <input 
              type="text" 
              name="telegramId" 
              placeholder="898009355" 
              value={formData.telegramId} 
              onChange={handleChange} 
              required 
              style={inputStyle} 
            />
            <div style={{ marginTop: '6px', fontSize: '12px', color: '#6272a4' }}>
              احصل على User ID من البوت: <a href="https://t.me/Get_myidrobot" target="_blank" rel="noopener noreferrer" style={{ color: '#8be9fd', textDecoration: 'underline' }}>@get_id_bot</a>
            </div>
            <div style={{ marginTop: '12px', textAlign: 'center' }}>
              <a href="https://drive.google.com/file/d/1XmNs_pG3Kpl0QW_XQ3Mgm4Jv1lBZSWsx/preview" target="_blank" rel="noopener noreferrer" style={{ display: 'inline-block', padding: '8px 16px', background: '#8be9fd', color: '#282a36', borderRadius: '6px', textDecoration: 'none', fontSize: '13px', fontWeight: 'bold' }}>
                🎥 شاهد شرح كيفية الحصول على Telegram ID
              </a>
            </div>
          </div>
          
          <div style={fieldGroupStyle}>
            <label style={labelStyle}>كود الدولة</label>
            <select 
              name="countryCode" 
              value={formData.countryCode} 
              onChange={handleChange} 
              style={inputStyle}
            >
              <option value="20">🇪🇬 مصر (20)</option>
            </select>
          </div>
          
          <div style={{ background: 'rgba(40, 42, 54, 0.5)', padding: '20px', borderRadius: '12px', margin: '20px 0' }}>
            <h3 style={{ color: '#8be9fd', marginBottom: '20px', fontSize: '16px', textAlign: 'center' }}>روابط التواصل الاجتماعي (اختياري)</h3>
            
            <div style={fieldGroupStyle}>
              <label style={labelStyle}>Facebook URL</label>
              <input 
                type="url" 
                name="facebookUrl" 
                placeholder="رابط صفحة الفيسبوك" 
                value={formData.facebookUrl} 
                onChange={handleChange} 
                style={inputStyle} 
              />
            </div>
            
            <div style={fieldGroupStyle}>
              <label style={labelStyle}>Instagram URL</label>
              <input 
                type="url" 
                name="instagramUrl" 
                placeholder="رابط حساب الانستجرام" 
                value={formData.instagramUrl} 
                onChange={handleChange} 
                style={inputStyle} 
              />
            </div>
          </div>
          
          <div style={{ background: 'rgba(40, 42, 54, 0.5)', padding: '20px', borderRadius: '12px', margin: '20px 0' }}>
            <h3 style={{ color: '#8be9fd', marginBottom: '20px', fontSize: '16px', textAlign: 'center' }}>📦 بيانات EasyOrder</h3>
            
            <div style={{ marginBottom: '20px', textAlign: 'center' }}>
              <a href="https://drive.google.com/file/d/1aC5JCwBG0VBNzwRbJ0Kw6A7An4eV3ela/preview" target="_blank" rel="noopener noreferrer" style={{ display: 'inline-block', padding: '10px 20px', background: 'linear-gradient(135deg, #ff79c6 0%, #bd93f9 100%)', color: '#fff', borderRadius: '8px', textDecoration: 'none', fontSize: '14px', fontWeight: 'bold', boxShadow: '0 4px 12px rgba(255, 121, 198, 0.3)' }}>
                🎬 شاهد شرح إعداد EasyOrder
              </a>
            </div>
            
            <div style={fieldGroupStyle}>
              <label style={labelStyle}>دومين EasyOrder</label>
              <input 
                type="text" 
                name="easyOrderDomain" 
                placeholder="مثال: mystore.easyorder.com" 
                value={formData.easyOrderDomain} 
                onChange={handleChange} 
                required 
                style={inputStyle} 
              />
            </div>
            
            <div style={fieldGroupStyle}>
              <label style={labelStyle}>Store ID</label>
              <input 
                type="text" 
                name="easyOrderStoreId" 
                placeholder="Store ID" 
                value={formData.easyOrderStoreId} 
                onChange={handleChange} 
                required 
                style={inputStyle} 
              />
            </div>
            
            <div style={fieldGroupStyle}>
              <label style={labelStyle}>API Key</label>
              <input 
                type="text" 
                name="easyOrderApiKey" 
                placeholder="API Key" 
                value={formData.easyOrderApiKey} 
                onChange={handleChange} 
                required 
                style={inputStyle} 
              />
            </div>
          </div>
          
          <div style={fieldGroupStyle}>
            <label style={labelStyle}>لغة الرسالة / Message Language <span style={{ color: '#ff5555' }}>*</span></label>
            <div style={{ marginBottom: '8px', fontSize: '12px', color: '#6272a4' }}>
              اختر لغة رسائل الواتساب المرسلة لعملائك
            </div>
            <div style={{ display: 'flex', gap: '12px' }}>
              <label style={{
                flex: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
                padding: '12px',
                borderRadius: '10px',
                border: formData.messageLanguage === 'ar' ? '2px solid #6272a4' : '2px solid #44475a',
                background: formData.messageLanguage === 'ar' ? 'rgba(98,114,164,0.2)' : 'transparent',
                cursor: 'pointer',
                fontWeight: 600,
                color: '#f8f8f2',
                transition: 'all 0.2s',
              }}>
                <input
                  type="radio"
                  name="messageLanguage"
                  value="ar"
                  checked={formData.messageLanguage === 'ar'}
                  onChange={handleChange}
                  style={{ display: 'none' }}
                />
                AR - عربي
              </label>
              <label style={{
                flex: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
                padding: '12px',
                borderRadius: '10px',
                border: formData.messageLanguage === 'en' ? '2px solid #6272a4' : '2px solid #44475a',
                background: formData.messageLanguage === 'en' ? 'rgba(98,114,164,0.2)' : 'transparent',
                cursor: 'pointer',
                fontWeight: 600,
                color: '#f8f8f2',
                transition: 'all 0.2s',
              }}>
                <input
                  type="radio"
                  name="messageLanguage"
                  value="en"
                  checked={formData.messageLanguage === 'en'}
                  onChange={handleChange}
                  style={{ display: 'none' }}
                />
                EN - English
              </label>
            </div>
          </div>

          <button type="submit" disabled={loading} style={buttonStyle}>
            {loading ? 'جاري الإنشاء...' : 'إنشاء حساب'}
          </button>
        </form>
        
        {error && <p style={{ background: '#ff5555', color: '#fff', padding: '12px', borderRadius: '8px', marginTop: '20px', textAlign: 'center', fontWeight: 'bold' }}>{error}</p>}
        
        <p style={{textAlign: 'center', marginTop: '20px', color: '#f8f8f2', fontSize: '14px'}}>
          لديك حساب بالفعل؟ <Link to="/" style={{color: '#8be9fd', fontWeight: 'bold', textDecoration: 'underline'}}>سجل دخول من هنا</Link>
        </p>
      </div>
    </div>
  );
}

// Styles
const fieldGroupStyle = {
  marginBottom: '20px',
};

const labelStyle = {
  display: 'block',
  marginBottom: '8px',
  color: '#f8f8f2',
  fontWeight: '600',
  fontSize: '14px',
};

const inputStyle = {
  width: '100%',
  padding: '12px 15px',
  border: '2px solid #44475a',
  borderRadius: '8px',
  fontSize: '14px',
  transition: 'all 0.3s ease',
  direction: 'ltr',
  textAlign: 'left',
  boxSizing: 'border-box',
  background: '#282a36',
  color: '#f8f8f2',
};

const buttonStyle = {
  width: '100%',
  padding: '15px',
  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  color: 'white',
  border: 'none',
  borderRadius: '10px',
  fontSize: '16px',
  fontWeight: 'bold',
  cursor: 'pointer',
  transition: 'all 0.3s ease',
  marginTop: '20px',
};

export default SignupPage;